// product slider
// $(document).ready(function() {
//   $('.print-box-wrapper').slick({
//     arrows: true,
//     prevArrow: '<button type="button" class="carousel__navigation-button carousel__navigation-button--back"> </button>',
//     nextArrow: '<button type="button" class="carousel__navigation-button carousel__navigation-button--forward"> </button>',
//   });




// });

$('.print-box-wrapper').slick({
  arrows: true,
  prevArrow: '<button type="button" class="carousel__navigation-button-cstm carousel__navigation-button--back"> <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="m17.146 6 5.894 6.438m0 0-5.894 6.437m5.894-6.437H0" stroke="currentColor" stroke-width="1.971"/> </svg> </button>',
  nextArrow: '<button type="button" class="carousel__navigation-button-cstm carousel__navigation-button--forward"> <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="m17.146 6 5.894 6.438m0 0-5.894 6.437m5.894-6.437H0" stroke="currentColor" stroke-width="1.971"/> </svg> </button>',
  slidesToShow: 1,
  slidesToScroll: 1
});


// On color swatch click

$('.product__color-swatch').on('click', function () {
  setTimeout(function () {
    $('.print-box-wrapper').slick('setPosition');
  }, 200);
});


// On page load

$(window).on('load', function () {
  setTimeout(function () {
    if ($('.print-box-wrapper').hasClass('slick-initialized')) {
      $('.print-box-wrapper').slick('setPosition');
    }
  }, 300);
});

// ******************************************************************************************************************

// inner accordion js
$(document).ready(function() {
    $(".accordion-header").click(function() {
      var content = $(this).next(".accordion-content");

      $(".accordion-content").not(content).slideUp();
      $(".accordion-header").not(this).removeClass("active");

      content.slideToggle();
      $(this).toggleClass("active");
    });
  });

// swatches functionality for colors
$(document).ready(function() {
  jQuery(document).on('click', '.product__color-swatch', function () {
    jQuery('.product__color-swatch').removeClass('newvariant');
    jQuery(this).addClass('newvariant');
    if ($(this).hasClass("newvariant")) {
      let myVariantLable = $(this).attr('myDataLabel');
        $('.custom-section').each(function(index, element) {
          if ($(element).attr('id') == myVariantLable) {
            console.log( 'matched')
            $('.custom-section').removeClass('myShow')
            $(this).addClass('myShow')
        }
     });
    }
  });


 // ✅ On page load: Check if any color swatch has 'newvariant' class
  let defaultSwatch = $('.product__color-swatch.newvariant');
  if (defaultSwatch.length > 0) {
    let myVariantLable = defaultSwatch.attr('myDataLabel');

    $('.custom-section').each(function(index, element) {
      if ($(element).attr('id') == myVariantLable) {
        $('.custom-section').removeClass('myShow');
        $(element).addClass('myShow');
      }
    });
  }



});

// View Pattern Hide Show

document.addEventListener('click', function (event) {
  // Handle button 1
  if (event.target && event.target.id === 'toggleButton-cstm') {
    const container = event.target.closest('.custom-section')?.querySelector('.custom-container');
    if (!container) return;

    container.classList.toggle('collapsed');
    event.target.textContent = container.classList.contains('collapsed')
      ? 'Show Content'
      : 'View Pattern';
  }

  // Handle button 2
  if (event.target && event.target.id === 'toggleButton-cstm-2') {
    const section = event.target.closest('.custom-section');
    const container = section?.querySelector('.custom-container');
    const toggleButton = section?.querySelector('#toggleButton-cstm');
    if (!container || !toggleButton) return;

    container.classList.toggle('collapsed');
    toggleButton.textContent = container.classList.contains('collapsed')
      ? 'Show Content'
      : 'View Pattern';
  }
});
